import { render, staticRenderFns } from "./tree-virtual-node.vue?vue&type=template&id=994363a2"
import script from "./tree-virtual-node.vue?vue&type=script&lang=js"
export * from "./tree-virtual-node.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports